import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Liest das csrf_token-Cookie (vom Backend per Double-Submit-Cookie-Pattern
// gesetzt, siehe app/middleware/csrf.py) — nicht httpOnly, extra für JS lesbar.
export function getCsrfToken(): string {
  const name = 'csrf_token=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const parts = decodedCookie.split(';');
  for (let part of parts) {
    while (part.charAt(0) === ' ') part = part.substring(1);
    if (part.indexOf(name) === 0) return part.substring(name.length);
  }
  return '';
}

// Request interceptor — CSRF-Token bei jedem Request mitschicken
api.interceptors.request.use((config) => {
  const csrfToken = getCsrfToken();
  if (csrfToken) {
    config.headers['X-CSRF-Token'] = csrfToken;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
